import { render, staticRenderFns } from "./SingleThreewaySwitch.vue?vue&type=template&id=80c8f804"
import script from "./SingleThreewaySwitch.vue?vue&type=script&lang=js"
export * from "./SingleThreewaySwitch.vue?vue&type=script&lang=js"
import style0 from "./SingleThreewaySwitch.vue?vue&type=style&index=0&id=80c8f804&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports